import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowDropDown = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_drop_down" {...props} />
))

ArrowDropDown.displayName = 'ArrowDropDown'

export default ArrowDropDown
